

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface ServiceCategoryParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface ServiceCategory {
    id?: any;
    tenantId: any;
    branchId: any;
    code:any;
    name:string;
    isActive:string;
    sortOrder:string;
    createdBy:any;
    isProcedureOrSurgery?:boolean;

    parameters?: ServiceCategoryParameter[];
    links?: any;
}
export interface NphiesServiceCategory {
    id?: any;
    tenantId: any;
    branchId: any;
    code:any;
    categoryName:string;
    isActive:boolean;
    displayOrder: number;
    groupNameId: number;
    createdBy:any;
    parameters?: ServiceCategoryParameter[];
    links?: any;
}



export abstract class ServiceCategoryData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<any[]>;
    abstract create(url: string, data: any): Observable<any[]>;
    abstract update(url: string, data: any): Observable<any>;
    abstract delete(url: string): Observable<any>;
    abstract listsubcategory(url: string): Observable<any[]>;
}
